import Marionette from "backbone.marionette";

import InstancesTpl from "views/instances_s/instancesView.ejs";
import CSS from "views/instances/instances.css";

import OptionsModel from "models/optionsModel.js";
var optionsModel = new OptionsModel();

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.View.extend({
    initialize: function() {


        $('.content-wrapper').css({ 'margin-left': '230px' });

        this.listenTo(S.mApp, "update:instances", function(ev) {

            this.collection.fetch({
                data: {
                    page: 1,
                    company: S.companyId
                },
                beforeSend: T.useToken
            });
        });

        this.listenTo(this.collection, "sync", this.applyView.bind(this));
    },

    template: InstancesTpl,
    render: function() {

        $("#loaderContainer").show();
        this.collection.fetch({
            data: {
                page: 1,
                company: S.companyId
            },
            beforeSend: T.useToken
        });
    },
    applyView: function() {
        $("#loaderContainer").hide();

        this.$el.html(this.template(this.collection));
        _.each(this.collection.models, function(model) {

            var li_sr = "files/icons/icon" + model.id;

            if (model.attributes['ext']) {
                li_sr = "files/icons/icon" + model.id + "." + model.attributes['ext'];
            }

            $("#icon" + model.id).attr("src", li_sr);
        });

        this.select();
    },
    events: {
        "click .instanceItem": "select",
        "click #AreasCarpeta a": "changeItemSelect"
    },
    select: function() {

        $("#AreasCarpeta").empty();

        if (S.instanceId) {

            $("#loaderContainer").show();
            optionsModel.fetch({
                data: {
                    instanceId: S.instanceId
                },

                beforeSend: T.useToken,

                success: function(inst) {
                    //$("#instanceName").html(" >> " + $(ev.target).parent().text());
                    S.userInfo.set({
                        options: inst.attributes.optionsR,
                        lang: inst.attributes.langR
                    });

                    S.mApp.trigger("recalculateAreas"); //Recalculate areas available
                    $(".navbar-nav > li").show();
                    $("#loaderContainer").hide();

                    //////EXPANDIR Y CONTRAER EL MENU DE LA BARRA LATERAL
                    $('#A_FUNC').attr("aria-expanded", "true");
                    $('#A_FUNC').removeClass("collapsed");

                    var target = $('#A_FUNC').data("target");
                    $(target).addClass('in');
                    $(target).attr("aria-expanded", "true");
                    $(target).css("height", "");

                    _.each(inst.attributes.optionsR, function(option) {
                        if (option.item == "A_FUNC") {
                            for (var i in option.children) {
                                var childOption = option.children[i];
                                var childText = inst.attributes.langR[childOption.item];

                                $("#AreasCarpeta").append('<div class="col-md-3 cent_fold ">' +
                                    '<a  id="' + childOption.item + '"  data-name="menu' + childOption.id + '" >' +
                                    '<span class="fold glyphicon glyphicon-folder-close"></span>' +
                                    '<b class="nameFold">' + childText + '</b>' +
                                    '</a></div>');

                            }


                        }

                    });



                    $("#AreasCarpeta").append('<div class="col-md-3 cent_fold  listfold_lo ">' +
                        '<a href="#lists" >' +
                        '<span class="fold  glyphicon glyphicon-list-alt"></span>' +
                        '<b class="nameFold">' + inst.attributes.langR['LISTS'] + '</b>' +
                        '</a></div>');




                }.bind(this),
                error: function() {

                    $("#loaderContainer").hide();
                }
            });
        }
    },
    changeItemSelect: function(ev) {

        var targetChild = $(ev.currentTarget).attr("data-name");
        var foldePare = $(ev.currentTarget).attr("id");



        if ($('#' + targetChild).attr('aria-expanded') === "true") {

            $('#' + targetChild).removeClass('in');
            $('#' + targetChild).attr("aria-expanded", "false");
            $('#' + targetChild).css("height", "0");

            $('#AreasCarpeta  #' + foldePare + ' span').removeClass();
            $('#AreasCarpeta #' + foldePare + ' span').addClass('fold glyphicon glyphicon-folder-close');

        } else {

            $('#' + targetChild).addClass('in');
            $('#' + targetChild).attr("aria-expanded", "true");
            $('#' + targetChild).css("height", "");

            $('#AreasCarpeta  #' + foldePare + ' span').removeClass();
            $('#AreasCarpeta  #' + foldePare + ' span').addClass('fold glyphicon glyphicon-folder-open');
        }



    }

});


//////////////////
// WEBPACK FOOTER
// ./app/views/instances_s/instancesView.js
// module id = 188
// module chunks = 0